import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #2c3e50;
  color: #ecf0f1;
  padding: 3rem 2rem;
  text-align: center;
`;

const FooterText = styled.p`
  font-size: 0.9rem;
`;

const Footer = () => {
    return (
        <FooterContainer>
            <h3>BeFriend Therapy</h3>
            <FooterText>
                Contact us: info@befriendtherapy.com
            </FooterText>
            <FooterText>
                &copy; {new Date().getFullYear()} BeFriend Therapy. All Rights Reserved.
            </FooterText>
        </FooterContainer>
    );
};

export default Footer;